<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectInitiator,
} from '../../../../model/additional-info/support/info-first-lesson-cancellation/select-initiator.hook'

defineOptions({
  name: 'SelectInitiator',
})

const {
  placeholder,
  model,
  options,
} = useSelectInitiator()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
